import { useEffect } from "react";

const setMetaTag = (name, content, attr = "name") => {
  if (!content) return;

  let element = document.querySelector(`meta[${attr}="${name}"]`);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attr, name);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
};

export const useDocumentMetaData = ({
  title,
  description,
  keywords,
  canonical,
  robots = "index, follow",
  author,
  ogTitle,
  ogDescription,
  ogImage,
  ogUrl,
  twitterCard = "summary_large_image",
  twitterTitle,
  twitterDescription,
  twitterImage,
}) => {
  useEffect(() => {
    if (title) document.title = title;

    setMetaTag("description", description);
    setMetaTag("keywords", keywords);
    setMetaTag("robots", robots);
    setMetaTag("author", author);

    // Canonical link
    if (canonical) {
      let link = document.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }

    // Open Graph (Facebook, LinkedIn, etc.)
    setMetaTag("og:title", ogTitle, "property");
    setMetaTag("og:description", ogDescription, "property");
    setMetaTag("og:image", ogImage, "property");
    setMetaTag("og:url", ogUrl, "property");

    // Twitter Cards
    setMetaTag("twitter:card", twitterCard, "name");
    setMetaTag("twitter:title", twitterTitle, "name");
    setMetaTag("twitter:description", twitterDescription, "name");
    setMetaTag("twitter:image", twitterImage, "name");
  }, [
    title,
    description,
    keywords,
    canonical,
    robots,
    author,
    ogTitle,
    ogDescription,
    ogImage,
    ogUrl,
    twitterCard,
    twitterTitle,
    twitterDescription,
    twitterImage,
  ]);
};